function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.311 21.9029L14.662 23.0904L12.2741 26.6656L6.311 25.3104V21.9029Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.689 21.9029L31.338 23.0904L33.7259 26.6656L39.689 25.3104V21.9029Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.338 23.0904L24.0971 23.6454C23.3666 23.697 22.6334 23.697 21.9029 23.6454L14.662 23.0904",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.7259 26.6656L32.5384 27.8531C27.2848 28.5603 21.9688 28.6815 16.6884 28.2145",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.689 21.9029L38.5015 19.5151L24.9103 20.2637C23.6204 20.33 22.328 20.33 21.0381 20.2637L7.49847 19.5151L6.311 21.9029",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M38.5015 19.5151L34.6294 11.7708C34.3442 11.1892 33.9014 10.6994 33.3515 10.3571C32.8015 10.0148 32.1665 9.83381 31.5188 9.83472H14.4296C13.7819 9.83381 13.1469 10.0148 12.5969 10.3571C12.047 10.6994 11.6042 11.1892 11.319 11.7708L7.44684 19.5151",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.2655 30.6024V27.5046C5.26643 26.9642 5.44311 26.4387 5.76888 26.0074L6.31099 25.3104",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M39.689 25.3104L40.2311 26.0074C40.5523 26.4403 40.7244 26.9657 40.7216 27.5046V30.6024C40.7161 30.8956 40.6166 31.1794 40.4377 31.4118C40.2587 31.6442 40.0098 31.8129 39.7277 31.8931L33.713 33.5839L29.3245 34.0744C26.0201 34.4355 22.6908 34.5133 19.3731 34.3067",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M39.689 31.9318V34.5133C39.6901 34.8384 39.5683 35.152 39.3482 35.3913C39.128 35.6306 38.8257 35.778 38.5015 35.804L33.8808 36.1138C33.5385 36.1138 33.2102 35.9778 32.9681 35.7357C32.726 35.4937 32.5901 35.1654 32.5901 34.823V33.713",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M43.303 17.3338V8.76339C43.3031 7.1497 42.6656 5.60134 41.5294 4.45546C40.3932 3.30958 38.8503 2.659 37.2366 2.64539H28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3337 2.64539H8.76336C7.14077 2.64539 5.58463 3.28996 4.43728 4.43731C3.28993 5.58466 2.64536 7.1408 2.64536 8.76339V17.3338",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6534 43.303H37.2366C38.8414 43.2896 40.3765 42.6461 41.5113 41.5113C42.6461 40.3766 43.2895 38.8414 43.303 37.2367V28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M2.64536 28.6534V37.2367C2.65897 38.8503 3.30955 40.3932 4.45543 41.5294C5.60131 42.6656 7.14967 43.3031 8.76336 43.303H17.3337",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 39.2889C14.9658 39.2889 17.3466 36.9081 17.3466 33.9711C17.3466 31.0342 14.9658 28.6534 12.0289 28.6534C9.09196 28.6534 6.71112 31.0342 6.71112 33.9711C6.71112 36.9081 9.09196 39.2889 12.0289 39.2889Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 36.3203C11.8406 36.3203 11.66 36.395 11.5269 36.5282C11.3938 36.6613 11.319 36.8419 11.319 37.0301C11.3054 37.1305 11.3134 37.2326 11.3425 37.3297C11.3716 37.4267 11.4211 37.5163 11.4878 37.5926C11.5544 37.6689 11.6366 37.7301 11.7288 37.772C11.821 37.8139 11.9211 37.8355 12.0224 37.8355C12.1237 37.8355 12.2238 37.8139 12.3161 37.772C12.4083 37.7301 12.4905 37.6689 12.5571 37.5926C12.6237 37.5163 12.6733 37.4267 12.7024 37.3297C12.7315 37.2326 12.7395 37.1305 12.7259 37.0301C12.7259 36.8441 12.6529 36.6655 12.5225 36.5327C12.3922 36.3999 12.2149 36.3236 12.0289 36.3203Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3448 30.8734V34.5907C11.3448 34.7687 11.4155 34.9394 11.5414 35.0652C11.6672 35.1911 11.838 35.2618 12.016 35.2618C12.194 35.2618 12.3647 35.1911 12.4906 35.0652C12.6164 34.9394 12.6871 34.7687 12.6871 34.5907V30.8734C12.6871 30.6954 12.6164 30.5247 12.4906 30.3988C12.3647 30.2729 12.194 30.2022 12.016 30.2022C11.838 30.2022 11.6672 30.2729 11.5414 30.3988C11.4155 30.5247 11.3448 30.6954 11.3448 30.8734Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
function SvgVehicleTooCloseToImgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTooCloseToImgEdge);
export default __webpack_public_path__ + "static/media/vehicle-too-close-to-img-edge.9732e4960e897e540aa9c7ef14023702.svg";
export { ForwardRef as ReactComponent };